export default "__VITE_ASSET__DDURd5gX__"